import { defineMessages } from 'react-intl';
import { LearningSessionError } from 'src/api/learningSessions/types';
import { ROUTES } from 'src/constants/routes.const';

export const msgs = defineMessages({
  notEnoughItemsToReview: {
    id: 'learning_session_not_enough_review_error',
  },
  learningSessionErrorLockedHeader: {
    id: 'learning_session_error_locked_header',
  },
  learningSessionErrorLockedDescription: {
    id: 'learning_session_error_locked_description',
  },
  learningSessionErrorCourseCompletedHeader: {
    id: 'learning_session_error_course_completed_header',
  },
  learningSessionErrorCourseCompletedDescription: {
    id: 'learning_session_error_course_completed_description',
  },
  learningSessionErrorGenericHeader: {
    id: 'learning_session_error_generic_header',
  },
  learningSessionErrorLearnHeader: {
    id: 'learning_session_error_learn_header',
  },
  learningSessionErrorLearnDescription: {
    id: 'learning_session_error_learn_description',
  },
  learningSessionErrorSessionTypeDescription: {
    id: 'learning_session_error_session_type_description',
  },
  learningSessionErrorReviewHeader: {
    id: 'learning_session_error_review_header',
  },
  learningSessionErrorReviewDescription: {
    id: 'learning_session_error_review_description',
  },
  learningSessionErrorDifficultHeader: {
    id: 'learning_session_error_difficult_header',
  },
  learningSessionErrorDifficultDescription: {
    id: 'learning_session_error_difficult_description',
  },
  learningSessionErrorSpeedHeader: {
    id: 'learning_session_error_speed_header',
  },
  learningSessionErrorSpeedDescription: {
    id: 'learning_session_error_speed_description',
  },
  whoops: {
    id: 'Whoops.',
  },
  couldNotLoad: {
    id: 'learning_session_error_generic_header',
  },
  wordlistDoesNotLoadHeader: { id: 'wordlist_completedscreen_header' },
  wordlistDoesNotLoadDescription: { id: 'wordlists_choosenext_header' },
  wordlistDoesNotLoadCta: { id: 'learnq_wordlistsCta' },
  reportBug: { id: 'learning_session_error_button_report_bug' },
  faqLink: { id: 'learning_session_error_faq_link' },
  learningSessionErrorPremiumScenarioDescription: {
    id: 'learning_session_error_premium_scenario_description',
    defaultMessage: 'This scenario is only for Pro users',
  },
  learningSessionErrorScenarioAlreadyCompleted: {
    id: 'learning_session_error_scenario_already_completed',
    defaultMessage: 'Looks like you already learned everything in this scenario',
  },
  learningSessionErrorPathAlreadyCompleted: {
    id: 'learning_session_error_path_already_completed',
    defaultMessage: 'Looks like you already learned everything in this path',
  },
});

export const LEARN_WORDLISTS_DOESNT_LOAD = 'LEARN_WORDLISTS_DOESNT_LOAD';

export const CODE_TO_MESSAGE: {
  [key: string]: LearningSessionError | undefined;
} = {
  UNAUTHORISED_FOR_PREMIUM_SESSION: {
    header: msgs.learningSessionErrorLockedHeader,
    description: msgs.learningSessionErrorLockedDescription,
    linkToPlans: true,
  },
  NOTHING_LEFT_TO_LEARN_MEMRISE: {
    header: msgs.learningSessionErrorCourseCompletedHeader,
    description: msgs.learningSessionErrorCourseCompletedDescription,
  },
  MULTIMEDIA_LEVEL_UNSUPPORTED: {
    header: msgs.learningSessionErrorGenericHeader,
    description: msgs.learningSessionErrorSessionTypeDescription,
  },
  LEARN_DOESNT_LOAD_MEMRISE: {
    header: msgs.learningSessionErrorLearnHeader,
    description: msgs.learningSessionErrorLearnDescription,
  },
  REVIEW_DOESNT_LOAD: {
    header: msgs.learningSessionErrorReviewHeader,
    description: msgs.learningSessionErrorReviewDescription,
  },
  DIFFICULT_WORDS_DOESNT_LOAD: {
    header: msgs.learningSessionErrorDifficultHeader,
    description: msgs.learningSessionErrorDifficultDescription,
  },
  SPEED_REVIEW_DOESNT_LOAD_MEMRISE: {
    header: msgs.learningSessionErrorSpeedHeader,
    description: msgs.learningSessionErrorSpeedDescription,
  },
  UNAUTHORISED_FOR_PREMIUM_SCENARIO: {
    header: msgs.whoops,
    description: msgs.learningSessionErrorPremiumScenarioDescription,
    linkToPlans: true,
  },
  SCENARIO_HAS_NOTHING_LEFT_TO_LEARN: {
    header: msgs.whoops,
    description: msgs.learningSessionErrorScenarioAlreadyCompleted,
  },
  PATH_HAS_NOTHING_LEFT_TO_LEARN: {
    header: msgs.whoops,
    description: msgs.learningSessionErrorPathAlreadyCompleted,
  },
  [LEARN_WORDLISTS_DOESNT_LOAD]: {
    header: msgs.wordlistDoesNotLoadHeader,
    description: msgs.wordlistDoesNotLoadDescription,
    extraInfoLink: {
      url: ROUTES.wordlists.choose,
      message: msgs.wordlistDoesNotLoadCta,
    },
  },
  DEFAULT: {
    header: msgs.whoops,
    description: msgs.couldNotLoad,
  },
};
